import { useToast } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { useCreateThreadActionMutation } from './mutations/CreateThreadAction.gql.generated';
import {
  BaseThreadFragmentFragmentGQLType,
  ThreadActionGQLType,
} from '../../../types/dashboard-core-gqlTypes.generated.d';
import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';
import { Icon } from '~/packages/common-frontend/components/icons';

// Helpers
const throttle = _.throttle((callback: () => Promise<void>) => callback(), 500);

// Exports
type PinThreadButtonProps = {
  thread: BaseThreadFragmentFragmentGQLType;
  onClick?: (action: ThreadActionGQLType) => void;
};
export const PinThreadButton = ({ thread, onClick }: PinThreadButtonProps) => {
  const toast = useToast();
  const [createThreadActionMutation] = useCreateThreadActionMutation();
  if (thread.resolved) return null;
  return (
    <IconButtonV2
      aria-label={thread.pinned ? 'Unpin Thread' : 'Pin Thread'}
      variant="primary-muted"
      colorScheme="gray"
      isActive={thread.pinned}
      size="sm"
      icon={<Icon icon="thumbtack" size="0.75rem" />}
      IconButtonProps={{
        height: '1.5rem',
        width: '1.5rem',
        minWidth: '1.5rem',
      }}
      onClick={() => {
        throttle(async () => {
          try {
            const action = thread.pinned ? 'unpin' : 'pin';
            await createThreadActionMutation({
              variables: {
                threadId: thread.threadId,
                action,
              },
            });
            onClick?.(action);
          } catch (error) {
            toast({
              title: thread.pinned
                ? 'Failed to unpin thread'
                : 'Failed to pin thread',
              status: 'error',
              position: 'top',
            });
          }
        });
      }}
    />
  );
};
